<template>
  <div class="duba-interests">
    <h3 class="duba-interests-title">
      {{ title }}
    </h3>
    <ul class="duba-interests-list clearfix">
      <li
        v-for="item in iconList"
        :key="item.alias"
        class="duba-interests-item"
        @click="handleIconClick(item)"
      >
        <div
          class="item-pic"
          :class="
            `${item.className} ${item.noRight ? item.className + '-grey' : ''}`
          "
        />
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p v-html="item.title" />
        <div
          v-if="item.alias === '121svr'"
          class="sprite-icon sprite-icon-1v1-tip tip"
        />
        <!-- 进度条 -->
        <ProgressBar v-show="item.showProgress && item.isProgressBar" />
      </li>
    </ul>
    <DubaTips
      v-show="installTipShow"
      :content="installTipContent"
      @cancle="installTipShow = false"
      @submit="installDuba"
    />
  </div>
</template>

<script>
import ProgressBar from '@/components/common/ProgressBar'
import { mapGetters } from 'vuex'
import DubaTips from '@/components/common/DubaTips'
import clientApi from '@/client'
export default {
  components: {
    ProgressBar,
    DubaTips
  },
  /* eslint-disable-next-line */
  data () {
    return {
      iconList: [
        {
          name: 'datarecovery',
          alias: 'data_recovery',
          className: 'item1',
          title: '数据恢复',
          showProgress: true,
          isProgressBar: false,
          progressTime: 4000,
          report: 18,
          hide: true,
          type: 'recover',
          from: 3030
        },
        {
          name: 'kfileprotect',
          alias: 'folder_encrypt',
          className: 'item9',
          title: '文件夹加密',
          showProgress: true,
          isProgressBar: false,
          report: 27,
          hide: true,
          type: 'protect',
          from: 3032
        },
        {
          name: 'kfiledestroy',
          alias: 'file_shred',
          className: 'item12',
          title: '文件粉碎',
          showProgress: true,
          isProgressBar: false,
          report: 49,
          hide: true,
          key_name: 'file_remove',
          from: 3033
        },
        {
          name: 'ksysslim',
          alias: 'system_disk_slim',
          className: 'item15',
          title: 'C盘瘦身专家',
          showProgress: true,
          isProgressBar: false,
          report: 50,
          hide: true,
          key_name: 'system_slim',
          from: 3034
        },
        {
          name: 'khomeprotectvip',
          alias: 'homepage_fix',
          className: 'item17',
          title: '浏览器<br/>主页修复',
          showProgress: true,
          isProgressBar: false,
          report: 51,
          hide: true,
          key_name: 'homepage_fix',
          from: 3035
        },
        {
          name: 'documentrepair',
          alias: 'docfix',
          className: 'item19',
          title: '文档修复',
          showProgress: true,
          isProgressBar: false,
          report: 58,
          hide: true,
          key_name: 'docfix',
          allowClick: true,
          from: 3036
        },
        {
          name: 'kdocprotect',
          alias: 'docprotect',
          className: 'item20',
          title: '文档卫士',
          showProgress: true,
          isProgressBar: false,
          report: 59,
          hide: true,
          key_name: 'docprotect',
          allowClick: true,
          from: 3037
        }
      ],
      installTipShow: false,
      selectedItem: {
        title: ''
      },
      vip_version: ''
    }
  },
  computed: {
    ...mapGetters(['isMember']),
    installTipContent () {
      return '该权益由金山毒霸客户端提供，是否立即安装并使用？'
    },
    title () {
      if (this.$route.name === 'Home') {
        return '以下特权需下载“金山毒霸”客户端'
      }
      return this.isMember ? '您已开通极光PDF金山联合会员，已享有以下特权(需下载金山毒霸)' : '极光PDF金山联合会员，享有以下特权(需下载金山毒霸)'
    }
  },

  mounted () {
  },
  created () {
    this.checkVipVersion()
  },
  methods: {
    async checkVipVersion () {
      const data = await clientApi.common.API.client_getVipVersion()
      this.vip_version = data.result
    },
    handleIconClick (item) {
      if (this.vip_version < 1) {
        this.$toast('请升级到最新版客户端')
        return
      }
      // 判断是否安装了毒霸
      clientApi.common.API.client_is_duba_installed().then(res => {
        if (res.result) {
          item.isProgressBar = true
          setTimeout(() => {
            item.isProgressBar = false
          }, item.progressTime || 2000)

          if (item.method) { item.method.call(this) } else { this.commonOpen(item.name, item.from) }
        } else {
          this.selectedItem = item
          // this.showInstallTip()
        }
      })
    },
    showInstallTip () {
      this.installTipShow = true
    },
    commonOpen (name, from) {
      clientApi.common.API.duba_app_common_open({
        name,
        from
      })
    },
    installDuba () {
      clientApi.common.API.client_install_duba({ name: this.selectedItem.name })
      this.installTipShow = false
    },
    toExaminationHome () {
      clientApi.common.API.client_openOptionWindow({
        url: `${location.protocol}//newvip.ijinshan.com/1335/examination/home?from=36`,
        open_opction: 8
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.duba-interests-title {
  color: #575757;
  font-size: 20px;
  margin-bottom: 10px;
  padding: 0 24px;
  font-weight: normal;
}
.duba-interests-list {
  padding-left: 9px;
}
.duba-interests-item {
  background: #fffbe9;
  width: 92px;
  height: 120px;
  position: relative;
  box-sizing: border-box;
  border: 1px solid #fdd63c;
  color: #000005;
  font-size: 14px;
  float: left;
  margin-left: 17px;
  text-align: center;
  line-height: 1.2;
  border-radius: 4px;
  margin-bottom: 22px;
  cursor: pointer;
  &:hover {
    background: #ffebde !important;
    border-color: #de461e !important;
  }
  .item-pic {
    width: 70px;
    height: 58px;
    margin: 12px auto 8px;
    background: url(~@/assets/images/privileges.png) no-repeat;
  }

  .tip {
    position: absolute;
    top: -12px;
    left: -4px;
  }
  .item1 {
    width: 64px;
    height: 64px;
    background-position: -0px -0px;
  }

  .item2 {
    width: 64px;
    height: 64px;
    background-position: -64px -0px;
  }

  .item3 {
    width: 64px;
    height: 64px;
    background-position: -128px -0px;
  }

  .item6 {
    width: 64px;
    height: 64px;
    background: url(~@/assets/images/interest/pop-window.png) no-repeat center center ;
  }

  .item4 {
    width: 64px;
    height: 64px;
    background-position: -256px -0px;
  }

  .item7 {
    width: 64px;
    height: 64px;
    background-position: -320px -0px;
  }

  .item8 {
    width: 64px;
    height: 64px;
    background-position: -384px -0px;
  }

  .item9 {
    width: 64px;
    height: 64px;
    background-position: -448px -0px;
  }

  .item10 {
    width: 64px;
    height: 64px;
    background-position: -512px -0px;
  }

  .item13 {
    width: 64px;
    height: 64px;
    background-position: -0px -64px;
  }

  .item12 {
    width: 64px;
    height: 64px;
    background-position: -64px -64px;
  }

  .item11 {
    width: 64px;
    height: 64px;
    background-position: -128px -64px;
  }

  .item14 {
    width: 64px;
    height: 64px;
    background-position: -192px -64px;
  }

  .item15 {
    width: 64px;
    height: 64px;
    background-position: -256px -64px;
  }

  .item16 {
    width: 64px;
    height: 64px;
    background-position: -320px -64px;
  }

  .item17 {
    width: 64px;
    height: 64px;
    background-position: -255px -193px;
  }
  .item18 {
    width: 64px;
    height: 64px;
    background-position: -384px -193px;
  }
  .item19 {
    width: 64px;
    height: 64px;
    background-position: -128px -251px;
  }
  .item20 {
    width: 64px;
    height: 64px;
    background-position: 2px -253px;
  }
  .item21 {
    width: 79px;
    height: 79px;
    background: url(~@/assets/images/wechatpa-qrcode.png);
    margin-top: 9px;
  }
}
</style>
